import React, { useEffect, useState } from "react";
import { getCommentLike_number, getReplyNumber, likeComment } from "../api";
import { useUserContext } from "../context/AuthContext";
import { isSameUser } from "../lib/utils";

const CommentInfo = ({ comment, appearReply, setSelectedComment }) => {
  const [reply_count, setReply_count] = useState();
  const [like, setLike] = useState();
  const [likerId, setLikerId] = useState(comment?.liker_id);

  const { authUser } = useUserContext();

  const handleLike = (id) => {
    likeComment(id);
    setLikerId((prev) => (isSameUser(prev, authUser?.id) ? null : authUser?.id));
  };

  const replyCount = () => {
    getReplyNumber(comment?.id).then((res) => {
      setReply_count(res.data["count"]);
    });
  };

  const likeCount = () => {
    getCommentLike_number(comment?.id).then((res) => {
      setLike(res.data["count"]);
    });
  };

  useEffect(() => {
    replyCount();
    likeCount();

    const interval = setInterval(() => {
      replyCount();
      likeCount();
    }, 500);

    return () => clearInterval(interval);
  }, [comment, likeCount, replyCount]);

  return (
    <div className="flex gap-5">
      <button className="flex items-center gap-1 text-sm" onClick={() => handleLike(comment?.id)}>
        <img src={isSameUser(likerId, authUser?.id) ? "/assets/icons/liked.svg" : "/assets/icons/like.svg"} className="h-4 w-4" alt="liked" />
        <span className="mb-1 font-medium text-gray-500">{like > 0 ? like : ""} like</span>
      </button>

      {reply_count > 0 && (
        <button className="flex items-center" onClick={() => { setSelectedComment(comment); appearReply(); }}>
          <span className="mb-1 font-medium text-gray-500">{reply_count} repl{reply_count === 1 ? "y" : "ies"}</span>
        </button>
      )}
    </div>
  );
};

export default CommentInfo;